module.exports = __webpack_public_path__ + "static/media/can.d2e683d2.svg";